import React from 'react';
import PropTypes from 'prop-types';

import PopOverMenu from '../../../PopOverMenu';
import Icon from '../../../Img/Icon';

// Matches MessageButton: the Figma 16×16 blue chat bubble (TMS-2332) so the admin (MessagePopover)
// and non-admin (MessageButton) rows show the same icon.
const MESSAGE_ICON = '/img/v3/icons/icon-message-bubble.svg';
const MESSAGE_ICON_SIZE = 16;

const options = {
    CALL: 'call',
    TEXT: 'text',
    EMAIL: 'email',
    MESSAGE: 'message',
};

const MessagePopover = props => {
    const { email, phone, onMessageClick } = props;
    const menuOptions = [];

    if (phone) {
        menuOptions.push({ label: `Call ${phone}`, value: options.CALL });
        menuOptions.push({ label: `Text ${phone}`, value: options.TEXT });
    }
    if (email) {
        menuOptions.push({ label: `Email ${email}`, value: options.EMAIL });
    }
    menuOptions.push({ label: 'Message on platform', value: options.MESSAGE });

    const onMenuSelected = (selected, e) => {
        e.stopPropagation();
        e.preventDefault();

        if (selected.value === options.CALL) {
            window.open(`tel:${phone}`);
        }
        if (selected.value === options.TEXT) {
            window.open(`sms:${phone}`);
        }
        if (selected.value === options.EMAIL) {
            window.open(`mailto:${email}`);
        }
        if (selected.value === options.MESSAGE) {
            onMessageClick();
        }
    };

    return (
        <PopOverMenu
            horizontalEllipsis={false}
            menuItems={menuOptions}
            onSelected={onMenuSelected}
            anchorClass="ml0 d-flex aic"
        >
            <div className="click-area click-area-24 text-v3-blue">
                <Icon src={MESSAGE_ICON} width={MESSAGE_ICON_SIZE} height={MESSAGE_ICON_SIZE} />
            </div>
            <i className="fas fa-solid fa-caret-down text-v3-blue fs14" />
        </PopOverMenu>
    );
};

MessagePopover.propTypes = {
    email: PropTypes.string,
    phone: PropTypes.string,
    onMessageClick: PropTypes.func,
};
MessagePopover.defaultProps = {
    email: null,
    phone: null,
    onMessageClick: () => {},
};

export default MessagePopover;
